import React from 'react'
import BatteryTrainingData from './BatteryTrainingData'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { makeStyles } from 'tss-react/mui'
import { BatteryTrainingMode } from 'src/Libs/system-data-handler'

const useStyles = makeStyles()(theme => ({
  contentAccordion: {
    padding: theme.spacing(0),
  },
  headerContent: {
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(4),
    },
  },
}))

interface Props {
  batteryTrainingMode: BatteryTrainingMode
  onUpdate: (trainingMode: boolean) => void
  disabledActions: boolean
}

const BatteryTraining: React.VFC<Props> = ({ batteryTrainingMode, onUpdate, disabledActions }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  return (
    <AccordionItem
      title={t('settings.battery.battery-training.title')}
      contentClassName={classes.contentAccordion}
      headerContentClassName={classes.headerContent}
    >
      <BatteryTrainingData batteryTrainingMode={batteryTrainingMode} onUpdate={onUpdate} disabledActions={disabledActions} />
    </AccordionItem>
  )
}

export default BatteryTraining
